import axios from "axios";

const api = axios.create({
  baseURL: "https://db-fluxoeasy-idq9.onrender.com/api",  // https://db-fluxoeasy-idq9.onrender.com/api ou http://localhost:5000/api
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  response => response,
  error => {
    const status = error.response?.status;
    const data   = error.response?.data;

    if (status === 403) {
      // Só redireciona se o backend EXPLICITAMENTE sinalizar bloqueio
      const isBloqueado =
        data?.bloqueado === true ||
        data?.code === "CLIENT_BLOCKED" ||
        data?.message?.toLowerCase().includes("bloqueado") ||
        data?.message?.toLowerCase().includes("inativo");

      if (isBloqueado) {
        window.location.href = "/acesso-bloqueado";
      }
      // 403 genérico (cold start, token expirado etc.) → apenas rejeita
    }

    return Promise.reject(error);
  }
);

export default api;